export default "__VITE_ASSET__u7ysyOPD__"